var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1013 7.98139L14.6842 3.44101C14.8283 3.30188 14.9428 3.13557 15.021 2.95189C15.0992 2.7682 15.1395 2.57086 15.1395 2.3715C15.1395 2.17214 15.0992 1.9748 15.021 1.79112C14.9428 1.60743 14.8283 1.44112 14.6842 1.30199C14.3977 1.01857 14.0095 0.859375 13.6046 0.859375C13.1998 0.859375 12.8116 1.01857 12.5251 1.30199L7.94227 5.84237L3.46126 1.30199C3.17483 1.01857 2.78656 0.859375 2.38174 0.859375C1.97692 0.859375 1.58865 1.01857 1.30222 1.30199C1.01615 1.58577 0.855469 1.97043 0.855469 2.3715C0.855469 2.77257 1.01615 3.15724 1.30222 3.44101L5.88508 7.98139L1.30222 12.5218C1.01973 12.8115 0.861828 13.1985 0.861828 13.6014C0.861828 14.0042 1.01973 14.3913 1.30222 14.681C1.59318 14.9578 1.97846 15.1162 2.38174 15.1249C2.78228 15.1217 3.1672 14.9706 3.46126 14.7011L8.04411 10.1406L12.5251 14.7011C12.8161 14.978 13.2014 15.1364 13.6046 15.1451C14.0097 15.1447 14.3979 14.9851 14.6842 14.7011C14.8289 14.5603 14.9438 14.3923 15.0223 14.2069C15.1008 14.0215 15.1412 13.8225 15.1412 13.6215C15.1412 13.4205 15.1008 13.2216 15.0223 13.0362C14.9438 12.8508 14.8289 12.6828 14.6842 12.5419L10.1013 7.98139Z",
    fill: "#2E75FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fafef1e9187f57df32c29e293d856d53.svg";
export { ForwardRef as ReactComponent };